export default __webpack_public_path__ + "static/media/media-partners3.a2e68676.webp";